import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
const copy = require('clipboard-copy');
import { Form, Button, InputGroup, FormControl } from 'react-bootstrap';
import notifier from '../../../../_utils/notifier';
import PropTypes from 'prop-types';


const PlaylistSharedForm = ({ id, shared, shared_link, onChangeShared }) => {

  const handleChange = (e) => {
    onChangeShared(e.currentTarget.checked);
  }

  const handleClick = () => {
    copy(shared_link);
    notifier.success(gettext('Ссылка успешно скопирована'));
  };

  return <div>
    <Form.Switch
      type="switch"
      id={ `playlist-switch-${id}` }
      label={ gettext('Открыть доступ') }
      checked={ shared }
      onChange={ handleChange }
      value={ shared ? 1 : 0 }
      className={'mb-3'}
    />
    <InputGroup className="mb-3">
      <FormControl
        placeholder={ gettext('Ссылка на плейлист') }
        aria-label={ gettext('Ссылка на плейлист') }
        aria-describedby="basic-addon2"
        readOnly={ true }
        disabled={ !shared }
        value={ shared_link }
      />
      <InputGroup.Append>
        <Button variant="outline-secondary" type="button" disabled={ !shared } onClick={ handleClick }
                title={ gettext('Скопировать ссылку') }>
          <i className="icon icon-floppy"></i>
        </Button>
      </InputGroup.Append>
    </InputGroup>
  </div>
}

PlaylistSharedForm.propTypes = {
  id: PropTypes.number.isRequired,
  shared: PropTypes.bool.isRequired,
  shared_link: PropTypes.string.isRequired,
  onChangeShared: PropTypes.func.isRequired,
}

export default compose(
  connect(null, {}),
)(PlaylistSharedForm);
